import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { withStyles } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import LinearProgress from '@material-ui/core/LinearProgress';

import Topbar from '../common/Topbar';
import Footer from '../common/Footer';
import TitleText from '../common/TitleText';
import MyTrace from './MyTrace';
import axiosInstance, { API_URL, normalise } from '../common/Constants';

//import HelmetMetaData from './HelmetMetaData';
import queryString from 'query-string';
// import ReactHelmet from '../common/ReactHelmet';

const styles = (theme) => ({
  background: {
    background: `url('/images/mypage/mypage_bg.png') #fafafa`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '120%',
    backgroundPosition: 'center top',
    [theme.breakpoints.down('sm')]: {
      backgroundSize: '200%',
    },
    [theme.breakpoints.down('xs')]: {
      backgroundSize: '250%',
    },
  },
  main: {
    width: '100%',
    // height: 'calc(100vh - 101.61px)',
    // overflowX: 'none',
    // overflowY: 'auto',
  },

  //card
  userCardMobile: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  userCardWeb: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  cardDiv: {
    marginTop: '23%',
    padding: '0 30px',
    [theme.breakpoints.down('md')]: {
      marginTop: '20%',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '40%',
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: '45%',
    },
  },
  cardRoot: {
    display: 'table',
    width: '70%',
    margin: 'auto',
    textAlign: 'center',
    padding: theme.spacing(1, 3),
    borderRadius: '20px',
    boxShadow: '0px 10px 10px 0 rgba(0, 0, 0, 0.02)',
    // border: '1px solid #000',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  cardTitle: {
    display: 'inline-block',
    borderBottom: `5px solid ${theme.palette.primary.main}`,
    fontSize: '1.8em',
    fontWeight: 700,
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.3em',
      marginBottom: theme.spacing(3),
      borderBottomWidth: '3px',
    },
  },
  userProfileImg: {
    width: theme.spacing(17),
    height: theme.spacing(17),
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(14),
      height: theme.spacing(14),
    },
  },
  userName: {
    fontSize: '1.2em',
    fontWeight: 'bold',
    padding: theme.spacing(1, 0, 2),
  },
  userState: {
    padding: theme.spacing(0, 2),
    display: 'flex',
    justifyContent: 'center',
  },
  userStateMobi: {
    textAlign: 'right',
  },
  chipRoot: {
    width: '100%',
  },
  chipLabel: {
    fontWeight: 'bold',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9em',
    },
  },
  cardNumDiv: {
    paddingTop: theme.spacing(1),
  },
  cardNumText: {
    color: theme.palette.primary.main,
    fontWeight: 800,
    fontSize: '1.5em',
  },
});

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 10,
    borderRadius: 5,
    // border: `1px solid ${theme.palette.primary.main}`,
  },
  colorPrimary: {
    backgroundColor: '#f3f3f3',
  },
  bar: {
    borderRadius: 0,
    backgroundColor: theme.palette.primary.point,
  },
}))(LinearProgress);

class MyPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profileImg: null, //프로필 이미지
      userInfo: '',
      totalCourse: 100, //완주코스 - 토탈
      completedCourse: 20, //완주코스 - 사용자 완주 갯수
      totalStamp: 206, //보유스탬프 - 토탈
      userStamp: 80, //보유스탬프 - 사용자 보유 갯수
      queryParamCourse: '', //쿼리파람으로 받은 코스 아이디
      queryParamStamp: '', //쿼리파람으로 받은 스탬프 아이디
      queryParamReview: '', //쿼리파람으로 받은 리뷰 아이디
      mode: 0, //0 readOnly, 1: insert, 2: modified
      isQueryParam: false,
    };
  }

  componentDidMount() {
    if (!localStorage.getItem('loggedin')) {
      this.props.history.replace('/login');
    } else {
      this.getUserInfo(localStorage.getItem('loggedin')).then(() => {
        //let info = JSON.parse(localStorage.getItem(`${localStorage.getItem('loggedin')}_status`));
        this.setState({
          userId: localStorage.getItem('loggedin'),
          // completedCourse: info.course.length,
          // userStamp: info.stamp.length,
        });
        this.fetchCourse();
      });
    }
  }

  resetQueryParam() {
    this.setState({ queryParamCourse: '', queryParamStamp: '' });
  }

  // 1. 코스만 받았을 경우
  // 2. 코스와 스탬프를 받았을 경우
  // 3. 리뷰 아이디를 받았을 경우
  fetchCourse() {
    if (this.props.location.search) {
      // console.log(queryString.parse(this.props.location.search));
      let queryParam = queryString.parse(this.props.location.search);
      if (queryParam.course && queryParam.stamp) {
        // console.log('queryParam course and stamp');
        axiosInstance
          .get(`${API_URL}/review/infoByStampId?userId=${localStorage.getItem('loggedin')}&stampId=${queryParam.stamp}`, {})
          .then((res) => {
            let bFound = false;
            if (res.data) {
              bFound = true;
            }
            if (bFound) {
              this.setState({ queryParamCourse: queryParam.course, queryParamStamp: queryParam.stamp, mode: 2, isQueryParam: true });
            } else {
              this.setState({ queryParamCourse: queryParam.course, queryParamStamp: queryParam.stamp, mode: 1, isQueryParam: true });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (queryParam.course) {
        // console.log('queryParam Course');
        this.setState({ queryParamCourse: queryParam.course, isQueryParam: true });
      } else if (queryParam.review) {
        // console.log('queryParam Review');
        // console.log(queryParam.review);
        axiosInstance
          .get(`${API_URL}/review/info?reviewId=${queryParam.review}`, {})
          .then((res) => {
            this.setState({
              queryParamCourse: res.data.course.id,
              queryParamStamp: res.data.stamp.id,
              queryParamReview: queryParam.review,
              mode: 0,
              isQueryParam: true,
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  }

  getUserInfo(id) {
    return new Promise((resolve) => {
      axiosInstance
        .get(`${API_URL}/user/info?userId=${id}`, {})
        .then((res) => {
          if (res && res.data) {
            this.setState({ userInfo: res.data }, () => {
              // console.log('사용자정보');
              // console.log(this.state.userInfo);
              this.setState({
                completedCourse: res.data.course && res.data.course.length ? res.data.course.length : 0,
                userStamp: res.data.stamp && res.data.stamp.length ? res.data.stamp.length : 0,
              });
            });
          } else {
            localStorage.removeItem(`${localStorage.getItem('loggedin')}_status`);
            localStorage.removeItem('loggedin');
            localStorage.clear();
            window.location.href = '/#/login';
          }
          resolve();
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  handleDetailToList() {
    // this.setState({ traceState: 'list' });
    // console.log(this.props);
    this.props.history.replace('/mypage');
  }

  render() {
    const { classes } = this.props;
    const currentPath = this.props.location;

    return (
      <React.Fragment>
        {/*
        <ReactHelmet
          keywords="성남누비길,남한산성남문"
          description="오늘 여기서 어쩌고 저쪼고 했음.."
          title="이것에 대한 타이틀"
          favicon="http://61.254.62.162:3000/assets/imgs/1.jpg"
        />
        */}
        <CssBaseline />
        <div className={classes.background}>
          <Topbar currentPath={currentPath} />
          <div className={classes.main}>
            <div className={classes.cardDiv}>
              <Card className={classes.cardRoot}>
                <CardContent>
                  <TitleText title="나의 발자취" type="narrowPadding" />
                  <div style={{ display: 'table', justifyContent: 'center', position: 'relative', margin: 'auto' }}>
                    <Avatar
                      alt="user_profile"
                      src={
                        !this.state.userInfo.img
                          ? '/images/mypage/default_profile.png'
                          : /^\b(uploads\/user\/.*)\b$/gi.test(this.state.userInfo.img)
                          ? `http://61.254.62.162:4002/${this.state.userInfo.img}`
                          : this.state.userInfo.img
                      }
                      className={classes.userProfileImg}
                    />
                  </div>
                  <Typography className={classes.userName}>{this.state.userInfo.name}</Typography>
                  <div style={window.matchMedia('(min-width: 960px)').matches ? { padding: '0 25%' } : { padding: '0 15%' }}>
                    <BorderLinearProgress
                      variant="determinate"
                      value={normalise(this.state.completedCourse, this.state.userInfo.totalCourse)}
                    />
                  </div>
                  <Grid
                    container
                    spacing={1}
                    style={{
                      borderTop: '1px solid #f1f1f1',
                      marginTop: '1.5em',
                      paddingTop: '1.5em',
                    }}
                    className={classes.userCardMobile}
                  >
                    <Grid item container xs={12}>
                      <Grid item xs={6}>
                        <Chip color="primary" label="보유 스탬프" classes={{ root: classes.chipRoot, label: classes.chipLabel }} />
                      </Grid>
                      <Grid item xs={6} className={classes.userStateMobi}>
                        <span className={classes.cardNumText}>{this.state.userStamp}</span> / {this.state.userInfo.totalStamp}
                      </Grid>
                    </Grid>
                    <Grid item container xs={12}>
                      <Grid item xs={6}>
                        <Chip color="primary" label="완주코스" classes={{ root: classes.chipRoot, label: classes.chipLabel }} />
                      </Grid>
                      <Grid item xs={6} className={classes.userStateMobi}>
                        <span className={classes.cardNumText}>{this.state.completedCourse}</span> / {this.state.userInfo.totalCourse}
                      </Grid>
                    </Grid>
                    <Grid item container xs={12}>
                      <Grid item xs={6}>
                        <Chip color="primary" label="완주율" classes={{ root: classes.chipRoot, label: classes.chipLabel }} />
                      </Grid>
                      <Grid item xs={6} className={classes.userStateMobi}>
                        <span className={classes.cardNumText}>
                          {this.state.userInfo.totalCourse && this.state.completedCourse
                            ? normalise(this.state.completedCourse, this.state.userInfo.totalCourse).toFixed(2)
                            : '0.00'}
                        </span>
                        %
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    style={{
                      borderTop: '1px solid #f1f1f1',
                      marginTop: '2em',
                      paddingTop: '2em',
                    }}
                    className={classes.userCardWeb}
                  >
                    <Grid item container xs={4} className={classes.userState}>
                      <div>
                        <Chip color="primary" label="보유 스탬프" classes={{ label: classes.chipLabel }} />
                        <div className={classes.cardNumDiv}>
                          <span className={classes.cardNumText}>{this.state.userStamp}</span> / {this.state.userInfo.totalStamp}
                        </div>
                      </div>
                    </Grid>
                    <Grid
                      item
                      container
                      xs={4}
                      className={classes.userState}
                      style={{ borderLeft: '1px solid rgba(0,0,0,0.1)', borderRight: '1px solid rgba(0,0,0,0.1)' }}
                    >
                      <div>
                        <Chip color="primary" label="완주코스" classes={{ label: classes.chipLabel }} />
                        <div className={classes.cardNumDiv}>
                          <span className={classes.cardNumText}>{this.state.completedCourse}</span> / {this.state.userInfo.totalCourse}
                        </div>
                      </div>
                    </Grid>
                    <Grid item container xs={4} className={classes.userState}>
                      <div>
                        <Chip color="primary" label="완주율" classes={{ label: classes.chipLabel }} />
                        <div className={classes.cardNumDiv}>
                          <span className={classes.cardNumText}>
                            {this.state.userInfo.totalCourse && this.state.completedCourse
                              ? normalise(this.state.completedCourse, this.state.userInfo.totalCourse).toFixed(2)
                              : '0.00'}
                          </span>
                          %
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </div>
            <div>
              <MyTrace
                courseId={this.state.queryParamCourse}
                stampId={this.state.queryParamStamp}
                reviewId={this.state.queryParamReview}
                userInfo={this.state.userInfo}
                mode={this.state.mode}
                isQueryParam={this.state.isQueryParam}
                callbackResetQueryParam={this.state.resetQueryParam}
                queryStr={queryString.parse(this.props.location.search)}
                handleDetailToList={this.handleDetailToList.bind(this)}
              />
            </div>
          </div>
          <Footer />
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(MyPage);
